// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!./releases.scss");
var ___CSS_LOADER_ICSS_IMPORT_1___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
exports.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
exports.push([module.id, ".vEUSNA7Cx{display:flex;flex-direction:column;width:100%}._6Ec0tOIrx{}._5NJmzMzlx{background-color:#303030;padding:20px}._1dmU9bMUx{display:flex;flex-direction:row;flex-grow:1;background-color:white;height:48px}.lVyaAxGFx{justify-content:center}._7qAuzmcKx{margin:0;border:none;background-color:#006fc8}._3CSjWbzwx{color:var(--primary-text-invert)}._74CWpfvfx{display:block}._2yXLgFsDx{display:none}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"app-info-and-releases": "vEUSNA7Cx",
	"appInfoAndReleases": "vEUSNA7Cx",
	"responsive-constraint": "_6Ec0tOIrx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["responsive-constraint"] + "",
	"responsiveConstraint": "_6Ec0tOIrx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["responsive-constraint"] + "",
	"notice-bar": "_5NJmzMzlx",
	"noticeBar": "_5NJmzMzlx",
	"menu-container": "_1dmU9bMUx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"menuContainer": "_1dmU9bMUx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"previous-version-container": "lVyaAxGFx _1dmU9bMUx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"previousVersionContainer": "lVyaAxGFx _1dmU9bMUx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"previous-version-from-email-container": "_7qAuzmcKx lVyaAxGFx _1dmU9bMUx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"previousVersionFromEmailContainer": "_7qAuzmcKx lVyaAxGFx _1dmU9bMUx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["vertically-center"] + "",
	"latest-version-link": "_3CSjWbzwx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["bold"] + "",
	"latestVersionLink": "_3CSjWbzwx " + ___CSS_LOADER_ICSS_IMPORT_1___.locals["bold"] + "",
	"visible": "_74CWpfvfx",
	"hidden": "_2yXLgFsDx"
};
module.exports = exports;
